import classNames from "classnames";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Popup from "reactjs-popup";

import { useMainStore } from "@/contexts/Store";

import arrowDown from "../../../images/table-image/icon/arrow-down-black.svg";
import { getWorkspaceLogo } from "../../helpers/getWorkspaceLogo";

const workspacesParameters = [
  {
    id: 0,
    name: "All Workspaces",
  },
];

type Props = {
  idSelection: (id: number) => void;
  workspaceID: number;
};

function NotificationsCenterNavigation({ idSelection, workspaceID }: Props) {
  // Import MobX stores
  const mainStore = useMainStore();

  // State
  const [showPopup, setShowPopup] = useState(false);

  // Hooks
  const location = useLocation();

  useEffect(() => {
    mainStore.tasks.myTasks({
      workspace_id: workspaceID,
    });
  }, [workspaceID]);

  // Helpers
  function addItemById(id: number) {
    idSelection(id);
    setShowPopup(false);
  }

  const filterTriggerClasses = classNames("workspace-filter-trigger", {
    active: showPopup,
  });
  const renderTrigger = (
    <div className={filterTriggerClasses}>
      {mainStore.workspaces.list
        .filter((workspace) => workspaceID === workspace.id)
        .map((workspace) => {
          const { logo } = getWorkspaceLogo(workspace);

          return (
            <div key={workspace.id} className="filter-trigger-element">
              <img src={logo} alt="workspace-icon" />
              {workspace.name}
            </div>
          );
        })}

      {workspacesParameters
        .filter((workspace) => workspaceID === workspace.id)
        .map((parameter) => (
          <div key={parameter.id} className="filter-trigger-element">
            {parameter.name}
          </div>
        ))}
      <img
        src={arrowDown}
        alt="arrow-down-icon"
        className="workspace-arrow-down"
      />
    </div>
  );

  const renderWorkspaces = mainStore.workspaces.list.map((workspace) => {
    const { logo } = getWorkspaceLogo(workspace);
    const triggerClasses = classNames("workspace-element", {
      active: workspaceID === workspace.id,
    });

    return (
      <div
        key={workspace.id}
        className={triggerClasses}
        onClick={() => addItemById(workspace.id)}
      >
        <img src={logo} alt="workspace-icon" />
        {workspace.name}
      </div>
    );
  });

  const renderParameterWorkspaces = workspacesParameters.map((parameter) => {
    const triggerClasses = classNames("workspace-element", {
      active: workspaceID === parameter.id,
    });

    return (
      <div
        key={parameter.id}
        className={triggerClasses}
        onClick={() => addItemById(parameter.id)}
      >
        {parameter.name}
      </div>
    );
  });

  return (
    <div className="settings-links-wrap">
      <ul>
        <li>
          <NavLink to="/notifications/tasks">Tasks</NavLink>
        </li>
        <li>
          <NavLink to="/notifications/reviews">Review Items</NavLink>
        </li>
      </ul>
      {location.pathname === "/notifications/tasks" && (
        <div className="all-new-task">
          <Popup
            trigger={() => renderTrigger}
            position="bottom right"
            open={showPopup}
            onOpen={() => setShowPopup(true)}
            onClose={() => setShowPopup(false)}
            offsetX={3}
            keepTooltipInside
          >
            <div className="select-small-wrap workspaces-filter-wrap">
              {renderParameterWorkspaces}
              {renderWorkspaces}
            </div>
          </Popup>
        </div>
      )}
    </div>
  );
}

export default observer(NotificationsCenterNavigation);
